/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { EventsContextTypes } from '../../types';

export const initExpensesContext = {
  currentViewName: 'Month',
  currentDate: new Date(),
  endDate: new Date(),
  paccvalue: [],
  sort: [{ columnName: 'time', direction: 'desc' }],
  hiddenColumnNames: ['userId'],
  pageSize: 10,
};

export const expensesReducer = (state: EventsContextTypes, action: any) => {
  switch (action.type) {
    case 'setCurrentViewName':
      return { ...state, currentViewName: action.payload };
    case 'setCurrentDate':
      return { ...state, currentDate: action.payload };
    case 'setEndDate':
      return { ...state, endDate: action.payload };
    case 'setPaccvalue':
      return { ...state, paccvalue: action.payload };
    case 'setSort':
      return { ...state, sort: action.payload };
    case 'setHiddenColumnNames':
      return { ...state, hiddenColumnNames: action.payload };
    case 'setPageSize':
      return { ...state, pageSize: action.payload };
    default:
      throw new Error('Unexpected action');
  }
};
